import React from 'react';
import { timeToString } from '../../../../../hooks/useTimer';
import { image } from '../../../../../utils/data/baseUrl';
import { useUser } from '../../../../../redux/reducer/user';
import { useAttemptsCooldown } from '../../../../../hooks/useAttemptsCooldown';

const MainEnergy = React.forwardRef(function (_, ref) {
  const { profile: { attempts } = {} } = useUser();
  const { time, percentageTime } = useAttemptsCooldown();

  return (
    !!time && (
      <div className={'main__energy-info'}>
        <div data-tutor-id={'energy-replenishment'} className={'main__bottom-timer'}>
          <div className={'main__bottom-timer-block'}>
            {/*<img src={image("energyG.svg")} className={"main__bottom-timer-image"}/>>*/}
            <div className={'main__bottom-timer-progress'} style={{ transform: `scaleX(${percentageTime}%)` }} />
            <div className={'main__bottom-timer-energy'}>
              <img src={image('energyB.svg')} />
              <span>{attempts}</span>
            </div>
            <div className={'main__bottom-timer-time'}>{timeToString(time)}</div>
          </div>
          {/*<CustomButton {...converterButton} onClick={openConverter}/>*/}
        </div>
      </div>
    )
  );
});
export default MainEnergy;
MainEnergy.propTypes = {};
